import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function PaymentsIntegration() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>Payments & Revenue Integrations</h1>
        <p>M-Pesa integrations and Revenue Authority filing automation.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Capabilities</h3>
          <ul>
            <li>M-Pesa STK Push and C2B integrations</li>
            <li>Automated receipts and reconciliation</li>
            <li>Revenue Authority submission & status checks</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/integrations/mpesa">M-Pesa Docs</a>
        </div>
      </div>
    </div>
  );
}

export default PaymentsIntegration;
